import React from "react";
import {
  ErrorBoundary as ReactErrorBoundary,
  ErrorBoundaryPropsWithComponent,
} from "react-error-boundary";
import loggy, { Severity } from "@catchoftheday/loggy";

export const ErrorBoundary: React.FC<Partial<ErrorBoundaryPropsWithComponent>> =
  ({ FallbackComponent, children, ...props }) => {
    const defaultFallbackComponent: React.FC = () => null;

    return (
      <ReactErrorBoundary
        onError={(e, { componentStack }) => {
          loggy.error(e, {
            level: Severity.Fatal,
            contexts: { react: { componentStack } },
          });
        }}
        FallbackComponent={FallbackComponent || defaultFallbackComponent}
        {...props}
      >
        {children}
      </ReactErrorBoundary>
    );
  };
